
const digest = 'ecb25b7d8efe31b4ca7b72c7df898a7c8c759f5821b6d8cfcb69403f4a72eab0';
const classes = {"wrapper":"_wrapper_aiibq_1","badge":"_badge_aiibq_8","content":"_content_aiibq_21","typeInfo":"_typeInfo_aiibq_31","checkbox":"_checkbox_aiibq_43"};
const css = `._wrapper_aiibq_1 {
  font-family: Rubik, "sans-serif";
  border: 1px solid #eaedf3;
  padding: 12px;
  box-shadow: 0 4px 0 0 rgba(226, 229, 237, 0.3);
  height: 100%;
}
._wrapper_aiibq_1 ._badge_aiibq_8 {
  background-color: #1452ac;
  border-radius: 4px;
  color: #ffffff;
  font-weight: 500;
  font-size: 10px;
  width: fit-content;
  padding: 3px 5px;
  position: absolute;
  top: 15px;
  left: 50px;
  z-index: 2;
}
._wrapper_aiibq_1 ._content_aiibq_21 {
  position: relative;
  width: 100%;
  border-radius: 3px;
  overflow-y: hidden;
  margin-bottom: 12px;
}
._wrapper_aiibq_1 ._content_aiibq_21 img {
  width: 100%;
}
._wrapper_aiibq_1 ._content_aiibq_21 ._typeInfo_aiibq_31 {
  font-weight: 600;
  font-size: 13px;
  color: #000;
  position: absolute;
  bottom: 10px;
  z-index: 1;
  width: 100%;
  text-align: center;
  background: rgba(255, 255, 255, 0.3490196078);
  padding: 4px 0;
}
._wrapper_aiibq_1 ._checkbox_aiibq_43 {
  align-items: flex-start;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  